/**
 * ScreenCheck Portal API
 * ScreenCheck Portal REST API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The EditReportShareTokenQuery model module.
 * @module model/EditReportShareTokenQuery
 * @version 0.0.1
 */
class EditReportShareTokenQuery {
    /**
     * Constructs a new <code>EditReportShareTokenQuery</code>.
     * @alias module:model/EditReportShareTokenQuery
     */
    constructor() { 
        
        EditReportShareTokenQuery.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>EditReportShareTokenQuery</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/EditReportShareTokenQuery} obj Optional instance to populate.
     * @return {module:model/EditReportShareTokenQuery} The populated <code>EditReportShareTokenQuery</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new EditReportShareTokenQuery();

            if (data.hasOwnProperty('report')) {
                obj['report'] = ApiClient.convertToType(data['report'], 'String');
            }
            if (data.hasOwnProperty('token')) {
                obj['token'] = ApiClient.convertToType(data['token'], 'String');
            }
            if (data.hasOwnProperty('label')) {
                obj['label'] = ApiClient.convertToType(data['label'], 'String');
            }
            if (data.hasOwnProperty('expiry')) {
                obj['expiry'] = ApiClient.convertToType(data['expiry'], 'String');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>EditReportShareTokenQuery</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>EditReportShareTokenQuery</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['report'] && !(typeof data['report'] === 'string' || data['report'] instanceof String)) {
            throw new Error("Expected the field `report` to be a primitive type in the JSON string but got " + data['report']);
        }
        // ensure the json data is a string
        if (data['token'] && !(typeof data['token'] === 'string' || data['token'] instanceof String)) {
            throw new Error("Expected the field `token` to be a primitive type in the JSON string but got " + data['token']);
        }
        // ensure the json data is a string
        if (data['label'] && !(typeof data['label'] === 'string' || data['label'] instanceof String)) {
            throw new Error("Expected the field `label` to be a primitive type in the JSON string but got " + data['label']);
        }
        // ensure the json data is a string
        if (data['expiry'] && !(typeof data['expiry'] === 'string' || data['expiry'] instanceof String)) {
            throw new Error("Expected the field `expiry` to be a primitive type in the JSON string but got " + data['expiry']);
        }

        return true;
    }


}



/**
 * @member {String} report
 */
EditReportShareTokenQuery.prototype['report'] = undefined;

/**
 * @member {String} token
 */
EditReportShareTokenQuery.prototype['token'] = undefined;

/**
 * @member {String} label
 */
EditReportShareTokenQuery.prototype['label'] = undefined;

/**
 * @member {String} expiry
 */
EditReportShareTokenQuery.prototype['expiry'] = undefined;






export default EditReportShareTokenQuery;

